import { render, staticRenderFns } from "./epb-virtual-scroller.component.vue?vue&type=template&id=6348c0e4&scoped=true"
import script from "./epb-virtual-scroller.component.vue?vue&type=script&lang=ts"
export * from "./epb-virtual-scroller.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-virtual-scroller.component.vue?vue&type=style&index=0&id=6348c0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6348c0e4",
  null
  
)

export default component.exports